import { Component } from '@angular/core';
import { MxpSnackBarService } from '../../../core/services/mxp-snackbar.service';
import { EnrollmentService } from '../../../core/services/enrollment.service';
import { UpdateEnrollmentRequest } from '../../../core/models/enrollment.model';
import { MatDialogRef } from '@angular/material/dialog';
import { MerchantService } from '../../../core/services/mxp-merchant.service';
@Component({
  selector: 'mxp-enrollment-signature-dialog',
  templateUrl: './enrollment-signature-dialog.component.html',
  styleUrls: ['./enrollment-signature-dialog.component.scss']
})
export class EnrollmentSignatureDialogComponent {

  showSpinner = false; 
  isSigned = false;
  byteArraySignature: Uint8Array = new Uint8Array();

  constructor(
    private enrollmentService: EnrollmentService,
    private mxpSnackBarService: MxpSnackBarService,
    private dialogRef: MatDialogRef<EnrollmentSignatureDialogComponent>,
    private merchantService: MerchantService
  ) { }

  handleIsEmptySignature(isSignatureEmpty: boolean) {
    this.isSigned = !isSignatureEmpty;
  }

  handleOnSaveSignature(signatureByteArray: Uint8Array) {
    if (signatureByteArray != undefined) {
      this.byteArraySignature = signatureByteArray;
      this.isSigned = true;
      return;
    }
    this.isSigned = false;
  }

  onSubmit() {
    this.showSpinner = true;
    const request: UpdateEnrollmentRequest = {
      userSignature: btoa(Array.from(this.byteArraySignature, byte => String.fromCharCode(byte)).join('')),
    };

    this.enrollmentService.updateEnrollment(request).subscribe(
      () => {
        this.showSpinner = false;
        this.dialogRef.close();        
        setTimeout(() => {
          this.merchantService.refreshMerchant();
        }, 300); // 300ms delay
        this.mxpSnackBarService.showSnackbarMessage('SNACKBAR.ENROLL_MERCHANT');
      },
      (error) => {
        this.showSpinner = false;
        this.dialogRef.close();
        this.mxpSnackBarService.showSnackbarMessage('SNACKBAR.ENROLL_MERCHANT_FAIL');
      },
    );
  }
}
